import { Component } from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {Button} from 'primeng/button';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-payment-success',
  imports: [
    TranslatePipe,
    Button,
    RouterLink
  ],
  templateUrl: './player-profile-payment-success.component.html',
  styleUrl: './player-profile-payment-success.component.scss'
})
export class PlayerProfilePaymentSuccessComponent
{
  // TODO: Token aktualisieren (!)
}
